import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import moment from 'moment';
import Base from '../js/base';
export default (function (props, ctx) {
  var profile = function profile() {
    return Base.profile();
  };

  var pn = 'div[data-name="cross-review-home"]';
  var time = '';
  var working_rows = [];
  var actor = 0;
  var actor_name = '';
  Base.app.off('actorSelected');
  Base.app.on('actorSelected', function (data) {
    $('.selected-actor').data('data', data);
    $('.selected-actor').html("Ng\u01B0\u1EDDi \u0111\xE1nh gi\xE1: <span class=\"text-color-white\">".concat(data.name, "</span>"));
    actor = data.id;
    actor_name = data.name;
  });

  var rated = function rated(row) {
    var $row = $('.review-emp-table').find("tr[data-id_emp=\"".concat(row.id_emp, "\"]"));
    var victim_name = $row.find('td[data-field="name"]').text();
    var params = "".concat(actor, "/").concat(actor_name, "/").concat(row.id_emp, "/").concat(victim_name, "/").concat(row.month);
    var link = "<a href=\"/cross-review-detail/".concat(params, "\">Xem \u0111\xE1nh gi\xE1</a>");
    $row.find(".review-button").html(link);
  };

  var viewResult = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var id_emp, month, $tableBody, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(actor === 0 || time === '')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", false);

            case 2:
              id_emp = $(pn + ' .selected-actor').data('data')['id'];
              month = $(pn + ' .detail-selected-time').data('month');
              $tableBody = $(pn + ' .review-emp-table tbody');
              $tableBody.html('');
              _context.next = 8;
              return Base.api('Review', 'viewWorkingTogether', {
                id_emp: id_emp,
                month: month
              });

            case 8:
              rs = _context.sent;
              working_rows = rs.working_rows; //Không có dữ liệu

              if (!(working_rows.length === 0)) {
                _context.next = 13;
                break;
              }

              Base.app.dialog.alert('Không có dữ liệu làm việc');
              return _context.abrupt("return", false);

            case 13:
              working_rows.forEach(function (row) {
                var $row = $("\n          <tr data-id_emp=\"".concat(row.id, "\">\n            <td class=\"label-cell\" data-field=\"name\">").concat(row.name, "</td>\n            <td class=\"numeric-cell\">").concat(row.count, "</td>\n            <td class=\"numeric-cell review-button\">Ch\u01B0a \u0111\xE1nh gi\xE1</td>\n          </tr>\n        "));
                $tableBody.append($row);
              });

              if (!(rs.rated_rows.length === 0)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              rs.rated_rows.forEach(function (row) {
                return rated(row);
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function viewResult() {
      return _ref.apply(this, arguments);
    };
  }();

  var selectTime = function selectTime(e) {
    var setSelectedTime = function setSelectedTime(_ref2) {
      var month = _ref2.month,
          text = _ref2.text;
      $('.detail-selected-time').data('month', month);
      $('.detail-selected-time').html("Th\u1EDDi gian: <span class=\"text-color-white\">".concat(text, "</span>"));
      time = text;
    };

    Base.app.dialog.create({
      content: "\n          <div><a class=\"button month-button\" data-month=\"last-month\">Th\xE1ng tr\u01B0\u1EDBc</a></div>\n          <div style=\"margin-top: 15px;\">Tu\u1EF3 ch\u1ECDn</div>\n          <div><input type=\"text\" name=\"month\" placeholder=\"M-YYYY\" style=\"width:100%; text-align:center; font-size: larger\" /></div>\n        ",
      destroyOnClose: true,
      closeByBackdropClick: true,
      on: {
        open: function open(dialog) {
          $(dialog.el).find('.month-button').click(function (e) {
            var month = $(e.target).data('month');
            var text = $(e.target).text();
            setSelectedTime({
              month: month,
              text: text
            });
            dialog.close();
          });
        }
      },
      buttons: [{
        text: 'Huỷ',
        color: 'gray'
      }, {
        text: 'OK',
        color: 'orange',
        onClick: function onClick(dialog) {
          var month = $(dialog.el).find('input[name="month"]').val();

          if (month === '') {
            Base.app.dialog.alert('Bạn cần chọn Tháng-Năm để xem đánh giá tuỳ chọn');
          } else {
            setSelectedTime({
              month: month,
              text: month
            });
          }
        }
      }]
    }).open();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="cross-review-home">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
        <div class="title sliding">Đánh giá chéo</div>
        <div class="right"><a href="#" @click=${profile} id="login-button"><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="page-content">
      <div class="list no-margin">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <a class="button selected-actor" href="/employee-list-popup/actorSelected">Chọn nhân viên</a>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <a class="button detail-selected-time" @click=${selectTime}>Chọn thời gian</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="block text-align-center" style="margin: 10px 0px;">
        <a class="button" @click=${viewResult}>Xem đánh giá</a>
      </div>
      <div class="data-table review-emp-table no-margin">
        <table>
          <thead>
            <tr>
              <th class="label-cell">Tên</th>
              <th class="numeric-cell">Số buổi</th>
              <th class="numeric-cell"></th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
  
    </div>
  </div>
  `
    }
    ;
});